import React, { useState, useEffect, useRef } from 'react';

import { 
    DashboardLayout, AlertMessage, FormInput_textarea, 
    Button, Spinner, ConfirmationModal, Datepicker,
    Dropdown
} from "components";

import { convertArrayToDropdownArrayFormat, func_validation, isStringEqual_caseSensitive, isStringTrimNotEmpty } from 'functions';

import ic_delete_invoices from 'assets/images/ic_delete_invoices.svg';
import ic_generate_invoice from 'assets/images/ic_generate_invoice.svg';
import ic_post_invoices from 'assets/images/ic_post_invoices.svg';
import ic_send_to_internal from 'assets/images/ic_send_to_internal.svg';
import ic_reset from 'assets/images/ic_reset.svg';
import ic_update from 'assets/images/ic_update.svg';

import 'assets/scss/billingPortal/modules/manualBilling/manualBilling.scss';
import { useCustomSelector } from 'hooks';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { Toaster } from 'components/notification/Toaster';



export default function ManualBillingPresentation(props) {
    // Props
    const {         
        resetFirebirdService_requesting,

        deleteInvoice_status,
        resetFirebirdService_status,

        deleteInvoice_requesting,

        getExistingDealerCodeList_requesting, getExistingSalesPersonCodeList_requesting,
        existingDealerCodeList, existingSalesPersonCodeList,

        updateDealerCode_status, updateSalesPersonCode_status,

        // Functions
        getExistingDealerCodeList = () => {},
        getExistingSalesPersonCodeList = () => {}
    } = props;

    // States

    const [datetime, setDatetime] = useState();
    const oldCode = useRef();
    const [isRerenderRequired, setIsRerenderRequired] = useState();
    const newCode = useRef();
    const [isModalVisible_deleteInvoice, setIsModalVisible_deleteInvoice] = useState(false);
    const [isModalVisible_resetFirebirdService, setIsModalVisible_resetFirebirdService] = useState(false);
    const { userPermissions } = useCustomSelector("userManagementReducers");

    
    // Text Area
    const {
        inputValues, updateChangedInputValue,
    } = useTextAreaHandler();

    // Errors
    const {
        isAlertMsgVisible, setIsAlertMsgVisible,
        alertMsg, setAlertMsg
    } = useHandleErrors(props);

    // Actions
    const {
        action, setAction,
        
        deleteInvoice,
        resetFirebirdService,

        submitButtonIcon, submitButtonText, 
        submitFunc, isSubmitLoading,

        isFormSubmissionAttempted
    } = useActionHandler({
        ...props,
        setAlertMsg,
        datetime,
        inputValues,
        oldCode, newCode,
        setIsModalVisible_deleteInvoice, setIsModalVisible_resetFirebirdService
    });

    // Load list of dealer and sales person code
    function getDealerAndSalesPersonCodeLists() {
        if (action == 7) {
            getExistingDealerCodeList();
        }
        else if (action == 8) {
            getExistingSalesPersonCodeList();
        }
    }
    useEffect(() => {
        getDealerAndSalesPersonCodeLists();
    }, [action]);

    // Reset inputs
    useEffect(() => {
        setDatetime("");
        oldCode.current = "";
        newCode.current = "";
    }, [action]);
    useEffect(() => {
        if (updateSalesPersonCode_status || updateDealerCode_status) {
            oldCode.current = "";
            newCode.current = "";
            setIsRerenderRequired("");
            getDealerAndSalesPersonCodeLists();
        }
    }, [updateDealerCode_status, updateSalesPersonCode_status])

    return (
        <DashboardLayout
            headerTitle={"Manual Billing"}

            headerDetailBody={(
                <React.Fragment>
                    {/* Delete Alert */}
                    <ConfirmationModal
                        description={"The inputted invoice(s) will be deleted."}
                        cancelButtonText={"Cancel"}
                        confirmButtonText={"Confirm"}
                        isModalVisible={isModalVisible_deleteInvoice}
                        updateParentState={setIsModalVisible_deleteInvoice}
                        handleOnConfirm={deleteInvoice}
				        isActionLoading={deleteInvoice_requesting}
                        isConfirmSuccessful={deleteInvoice_status}
                    />

                    {/* Reset Firebird Service Alert */}
                    <ConfirmationModal
                        description={"Firebird service will be reset."}
                        cancelButtonText={"Cancel"}
                        confirmButtonText={"Confirm"}
                        isModalVisible={isModalVisible_resetFirebirdService}
                        updateParentState={setIsModalVisible_resetFirebirdService}
                        handleOnConfirm={resetFirebirdService}
				        isActionLoading={resetFirebirdService_requesting}
                        isConfirmSuccessful={resetFirebirdService_status}
                    />
                </React.Fragment>
            )}
            
            bodyClassName={"manualBilling"}
            body={(
                <div className={"manualBillingWrapper d-flex flex-column " + (!(action == 6 || action == 7 || action == 8) && "h-100 ")}>
                    {/* Alert Error Messages */}
                    <AlertMessage
                        message={alertMsg}
                        isVisible={isAlertMsgVisible}
                        toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
                    />

                    {/* Sub Header */}
                    <div className={"manualBillingWrapper-body-header d-flex align-items-center justify-content-between "}>
                        <div className={"manualBillingWrapper-bodyHeader-title component-generalTable-customHeader-title "}>
                            Lists
                        </div>

                        {func_validation.isStringTrimNotEmpty(submitButtonText)? (
                            <Button
                                className={"manualBillingWrapper-bodyHeader-actionButton tableHeaderButtonPadding d-flex align-items-center"}
                                handleOnClick={submitFunc}

                                isLoading={isSubmitLoading}
                                isDisabled={
                                    ((action == 1) && !(userPermissions?.Internal_ProformaInvoice_Generate)) ||
                                    ((action == 2) && !(userPermissions?.Internal_SqlAccount_Post)) ||
                                    ((action == 3) && !(userPermissions?.Internal_ProformaInvoice_Send)) ||
                                    ((action == 4) && !(userPermissions?.Internal_ProformaInvoice_Send)) ||
                                    ((action == 5) && !(userPermissions?.Internal_ProformaInvoice_Delete)) ||
                                    ((action == 6) && !(userPermissions?.Internal_General_ResetService) ||
                                    ((action == 7 || action == 8) && !(userPermissions?.Internal_BillingSetup_Update) && !(userPermissions?.Internal_ProformaInvoice_Send)) ||
                                    ((action == 9) && !(userPermissions?.Internal_ProformaInvoice_Generate))) // ISSUE: need to update the permission
                                }
                                isDecoration_primaryTransparent
                            >
                                <img
                                    className={"main-action__icon"}
                                    src={submitButtonIcon}
                                    alt={"Action Icon"}
                                />
                                {submitButtonText}
                            </Button>
                        ):""}
                    </div>

                    <div className={"manualBillingWrapper-rowInput d-flex align-item-center "}>
                        {/* Action Type */}
                        <Dropdown
                            className={"manualBillingWrapper-actionType"}
                            label={"Action"}

                            placeholder={"Choose action"}

                            selectedValueClassName={"manualBillingWrapper-actionType-input"}

                            options={[
                                {
                                    label: "Generate Invoice",
                                    value: 1
                                },
                                {
                                    label: "Post to SQL",
                                    value: 2
                                },
                                {
                                    label: "Send Invoice (Internal)",
                                    value: 3
                                },
                                {
                                    label: "Send Invoice (Customer)",
                                    value: 4
                                },
                                {
                                    label: "Delete Invoice",
                                    value: 5
                                },
                                {
                                    label: "Reset Service",
                                    value: 6
                                },
                                {
                                    label: "Update Dealer Code",
                                    value: 7
                                },
                                {
                                    label: "Update Sales Person Code",
                                    value: 8
                                },
                                {
                                    label: "Generate Appendix",
                                    value: 9
                                },
                            ]}
                            onChange={setAction}

                            isInputValueTrim_onChange isInputRequired
                        />

                        {/* Date */}
                        {(action == 1 || action == 9)? (
                            <Datepicker
                                className={"manualBillingWrapper-nextBilledDate"}
                                inputClassName={"manualBillingWrapper-nextBilledDate-input"}

                                label={"Select Date"}
                                handleOnChange={setDatetime}

                                isMonthYear={action == 9}

                                isConversionRequired_ISO8601
                            /> 
                        ):""}

                        {(action == 7 || action == 8)? (
                            <>
                                {/* Dropdown */}
                                <Dropdown
                                    label={"Current Code"}
                                    isInputRequired

                                    options={(action == 7)? convertArrayToDropdownArrayFormat(existingDealerCodeList): convertArrayToDropdownArrayFormat(existingSalesPersonCodeList)}
                                    onChange={(value) => {
                                        oldCode.current = value;
                                        setIsRerenderRequired(value);
                                    }}

                                    isListLoading={getExistingDealerCodeList_requesting || getExistingSalesPersonCodeList_requesting}
                                    isResetRequired={updateSalesPersonCode_status || updateDealerCode_status}

                                    errorMsg={"Required"}

                                    isFormSubmissionAttempted={isFormSubmissionAttempted}
                                />

                                {/* Text */}
                                <FormInput_text  
                                    inputLabel={"New Code"}

                                    isInputBlurHandlingRequired
                                    handleInputBlurExtend={(value) => { 
                                        newCode.current = value;  
                                        setIsRerenderRequired(value);
                                    }}

                                    isFormSubmissionAttempted={isFormSubmissionAttempted} 
                                    isResetRequired={updateSalesPersonCode_status || updateDealerCode_status}

                                    isMarginBtmOptional
                                />
                            </>
                        ):""}
                    </div>

                    {!(action == 6 || action == 7 || action == 8) && (
                        <FormInput_textarea
                            className={"flex-fill"}
                            wrapperClassname={"d-flex flex-column h-100"}
                            customInputClassName={"manualBilling-input flex-fill"}
    
                            inputPlaceholder={(action == 1 || action == 9)? "300-M0001\n300-M0002\n300-M0003": "1123\n1124\n1125"}
                            inputLabel={(action == 1 || action == 9)? "Account Code": "Invoice ID"}
                            propagateValueChange={(stateName, value) => { updateChangedInputValue(value); }}
    
                            isMarginBtmOptional
                        />  
                    )}                   
                </div>                
            )}
        />
    );
}


function useTextAreaHandler() {
    const [inputValues, setInputValues] = useState([]);

    const [changedValue, setChangedValue] = useState("");
    const [changedValuePos, setChangedValuePos] = useState(0);

    function updateChangedInputValue(value, index) {
        setChangedValue(value);
        setChangedValuePos(index)
    }
    function updateInputValue(value) {
        if (func_validation.isStringTrimNotEmpty(value)) {
            // Remove Duplicate
            let inputList = value.split("\n");
            let referenceObj = {};
            let uniqueList = [];
            for (let i = 0; i < inputList.length; i++) {
                let item = inputList[i];
                if (!(referenceObj.hasOwnProperty(item)) &&
                    func_validation.isStringTrimNotEmpty(item)) {

                    referenceObj[item] = true;
                    uniqueList.push(item);
                }
            } 
            
            // For Multiline input
            setInputValues(uniqueList);
        }
    }
    useEffect(() => {
        updateInputValue(changedValue, changedValuePos);
    }, [changedValue, changedValuePos]);


    return {
        inputValues, updateChangedInputValue
    }
}

function useActionHandler(props) {
    const { 
        setAlertMsg, datetime, inputValues, totalRequests,
        setIsModalVisible_deleteInvoice, setIsModalVisible_resetFirebirdService,

        generateAppendix_requesting,
        generateInvoice_requesting,
        postToSQLAccount_requesting,
        sendEmail_requesting,

        oldCode, newCode,

        // Functions
        updateDealerCode = () => {},
        updateSalesPersonCode = () => {}
    } = props;

    const [isSendingInvoicesToCustomer, setIsSendingInvoicesToCustomer] = useState(false);

    const [isFormSubmissionAttempted, setIsFormSubmissionAttempted] = useState(false);

    const [action, setAction] = useState();

    function generateAppendix() {
        setAlertMsg("");
        setIsFormSubmissionAttempted(true);

        for (let i = 0; i < inputValues.length; i++) {
            let accountCode = inputValues[i];
            if (func_validation.isStringTrimNotEmpty(accountCode) &&
                func_validation.isFunction(props.generateAppendix)) {

                props.generateAppendix(accountCode, datetime);
            }
        }
    }

    function generateInvoice() {
        setAlertMsg("");
        setIsFormSubmissionAttempted(true);

        for (let i = 0; i < inputValues.length; i++) {
            let accountCode = inputValues[i];
            if (func_validation.isStringTrimNotEmpty(accountCode) &&
                func_validation.isFunction(props.generateInvoice)) {

                props.generateInvoice(accountCode, datetime);
            }
        }
    }

    function postToSQLAccount() {
        setAlertMsg("");
        setIsFormSubmissionAttempted(true);

        for (let i = 0; i < inputValues.length; i++) {
            let invoiceId = inputValues[i];
            if (func_validation.isStringTrimNotEmpty(invoiceId) &&
                func_validation.isFunction(props.postToSQLAccount)) {

                let invoiceId_trimmed = func_validation.getTrimmedString(invoiceId);
                props.postToSQLAccount(invoiceId_trimmed);
            }
        }
    }

    function sendEmail(isSentToCustomers) {
        setAlertMsg("");
        setIsFormSubmissionAttempted(true);

        for (let i = 0; i < inputValues.length; i++) {
            let invoiceId = inputValues[i];
            if (func_validation.isStringTrimNotEmpty(invoiceId) &&
                func_validation.isFunction(props.sendEmail)) {

                let invoiceId_trimmed = func_validation.getTrimmedString(invoiceId);

                if (isSentToCustomers) {
                    setIsSendingInvoicesToCustomer(true);
                    props.sendEmail(invoiceId_trimmed, true);
                }
                else props.sendEmail(invoiceId_trimmed);
            }
        }
    }

    function deleteInvoice() {
        setAlertMsg("");
        setIsFormSubmissionAttempted(true);

        for (let i = 0; i < inputValues.length; i++) {
            let invoiceId = inputValues[i];
            if (func_validation.isStringTrimNotEmpty(invoiceId) &&
                func_validation.isFunction(props.deleteInvoice)) {

                let invoiceId_trimmed = func_validation.getTrimmedString(invoiceId);
                props.deleteInvoice(invoiceId_trimmed);
            }
        }
    }

    function resetFirebirdService() {
        setIsFormSubmissionAttempted(true);

        if (props.resetFirebirdService)
            props.resetFirebirdService();
    }

    function resetRequestStatus() {
        if (totalRequests == 0) {
            setIsSendingInvoicesToCustomer(false);
        }
    }
    useEffect(() => {
        resetRequestStatus();
    }, [totalRequests]);


    // Submit Button
    let submitButtonIcon = "";
    let submitButtonText = "";
    let submitFunc = () => {};
    let isSubmitLoading = false;
    switch (action) {
        case 1:
            submitButtonIcon = ic_generate_invoice;
            submitButtonText = "Generate";
            submitFunc = generateInvoice;
            isSubmitLoading = generateInvoice_requesting;
            break;
        case 2:
            submitButtonIcon = ic_post_invoices;
            submitButtonText = "Post";
            submitFunc = postToSQLAccount;
            isSubmitLoading = postToSQLAccount_requesting;
            break;
        case 3:
            submitButtonIcon = ic_send_to_internal;
            submitButtonText = "Send";
            submitFunc = () => { sendEmail(false); };
            isSubmitLoading = sendEmail_requesting &&
                (!isSendingInvoicesToCustomer);
            break;
        case 4:
            submitButtonIcon = ic_send_to_internal;
            submitButtonText = "Send";
            submitFunc = () => { sendEmail(true); };
            isSubmitLoading = sendEmail_requesting &&
                isSendingInvoicesToCustomer;
            break;
        case 5:
            submitButtonIcon = ic_delete_invoices;
            submitButtonText = "Delete";
            submitFunc = () => { setIsModalVisible_deleteInvoice(true); };
            break;
        case 6:
            submitButtonIcon = ic_reset;
            submitButtonText = "Reset";
            submitFunc = () => { setIsModalVisible_resetFirebirdService(true); };
            break;
        case 7: case 8:
            submitButtonIcon = ic_update;
            submitButtonText = "Update";
            submitFunc = () => {
                if (isStringTrimNotEmpty(oldCode.current) && isStringTrimNotEmpty(newCode.current)) {
                    if (!isStringEqual_caseSensitive(oldCode.current, newCode.current)) {
                        if (action == 7)
                            updateDealerCode(oldCode.current, newCode.current);
                        else if (action == 8)
                            updateSalesPersonCode(oldCode.current, newCode.current);
                    }
                    else {
                        Toaster({
                            type: "info",
                            msg: "New code & current code cannot be the same"
                        })
                    }
                }
                else {
                    Toaster({
                        type: "info",
                        msg: "Both current code and new code inputs required"
                    })
                }
            }
            break;
        case 9:
            submitButtonIcon = ic_generate_invoice; // ISSUE: need to update icon
            submitButtonText = "Generate";
            submitFunc = generateAppendix;
            isSubmitLoading = generateAppendix_requesting;
            break;
    }

    return {
        action,
        setAction,

        isSendingInvoicesToCustomer,

        generateInvoice,
        postToSQLAccount,
        sendEmail,
        deleteInvoice,
        resetFirebirdService,

        submitButtonIcon, submitButtonText, 
        submitFunc, isSubmitLoading,

        isFormSubmissionAttempted
    }
}


function useHandleErrors(props) {
    const { 
        generateInvoice_errorMsg, 
        postToSQLAccount_errorMsg, 
        sendEmail_errorMsg,
        deleteInvoice_errorMsg,
        resetFirebirdService_errorMsg
    } = props;

    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");

    // Error Messages
    function updateErrorMsg(msg) {
        if (func_validation.isStringTrimNotEmpty(msg)) {
            setAlertMsg(msg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        updateErrorMsg(generateInvoice_errorMsg);
    }, [generateInvoice_errorMsg]);
    useEffect(() => {
        updateErrorMsg(postToSQLAccount_errorMsg);
    }, [postToSQLAccount_errorMsg]);    
    useEffect(() => {
        updateErrorMsg(sendEmail_errorMsg);
    }, [sendEmail_errorMsg]);
    useEffect(() => {
        updateErrorMsg(deleteInvoice_errorMsg);
    }, [deleteInvoice_errorMsg]);
    useEffect(() => {
        updateErrorMsg(resetFirebirdService_errorMsg);
    }, [resetFirebirdService_errorMsg]);

    return {
        isAlertMsgVisible, setIsAlertMsgVisible,
        alertMsg, setAlertMsg,
    }
}